// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>VA’s Appeals APIs allow a user/application to manage a Veteran's Appeal information.</p>
      <h2 id="which-api-should-i-use%3F">Which API should I use?</h2>
      <p>The <strong>Appeals Status API</strong> is for internal VA use only.  It allows for retrieving the status of all Appeals associated to a Veteran.  These statuses are read-only, and can include Appeals within the legacy process as well as the new Appeals Modernization Act (AMA) process.  You can learn more about the AMA <a href="https://benefits.va.gov/benefits/appeals.asp">here</a>.</p>
      <p>The <strong>Decision Reviews API</strong> is currently for internal VA use as well, though will include OAuth authentication in the future.  This API allows for submitting Decision Review requests in accordance with the AMA process.  It also allows for retrieving the details and status of Decision Review requests associated to a Veteran.</p>
      <h2 id="developement-api-access">Developement API Access</h2>
      <p>To gain access to the Decision Reviews API you must request an API Key. Your API Key will need to be included as a header on all of your requests.</p>
      <h2 id="developer-guidelines">Developer Guidelines</h2>
      <p>Below are guidelines you should follow to be successful in your VA API integration.</p>
      <h3 id="data-refresh">Data Refresh</h3>
      <p>Sandbox points to the Caseflow Demo environment which refreshes daily.  The data in this environment is mock data and does not contain any PII.</p>
    </div>
  );
};

export default MarkdownComponent;
